import { Button } from "@mui/material";

export const getColumns = (onSerialNumberClick = () => {}) => [
  {
    label: "Serial Number",
    key: "serialNumber",
    filterable: true,
    render: (value, row) => {
      const { siteId } = row;
      return (
        <Button
          onClick={() => onSerialNumberClick(value, siteId)}
          sx={{
            color: "#1976d2",
            cursor: "pointer",
            textDecoration: "underline",
            fontWeight: 500,
            textTransform: "none",
            minWidth: "auto",
            padding: 0,
            "&:hover": {
              textDecoration: "underline",
              backgroundColor: "transparent",
            },
          }}
        >
          {value}
        </Button>
      );
    },
  },
  { label: "Site ID", key: "siteId" },
  { label: "Protocol", key: "protocol" },
  { label: "Protocol Version", key: "protocolVersion" },
  { label: "Vendor Name", key: "vendorName" },
  { label: "SKU", key: "sku" },
  { label: "Part Number", key: "partNum" },
  { label: "Model Name", key: "modelName" },
  { label: "Display Name", key: "displayName" },
  { label: "Reporting Interval (sec)", key: "reportingInterval" },
  { label: "Created At", key: "createdAt" },
  { label: "Last Reported At", key: "lastReportedAt" },
  { label: "Offline At", key: "offlineAt" },
  { label: "Updated At", key: "updatedAt" },
  { label: "Warranty Due Date", key: "warrantyDueDate" },
  { label: "Timezone", key: "timezone" },
  { label: "Country", key: "country" },
  {
    label: "Connection Status",
    key: "isConnected",
    render: value => (value ? "Connected" : "Disconnected"),
  },
  {
    label: "Retired",
    key: "isRetired",
    render: value => (value ? "Yes" : "No"),
  },
  {
    label: "Faulted",
    key: "isFaulted",
    render: value => (value ? "Yes" : "No"),
  },
  { label: "Firmware Version", key: "fwVersion" },
  { label: "Firmware Updated At", key: "fwUpdatedAt" },
  { label: "Commissioning Status", key: "commissioningStatus" },
  { label: "Mode", key: "mode" },
  {
    label: "Partner Integration",
    key: "hoControl",
    render: value => (value ? "No" : "Yes"),
  },
  {
    label: "DLB Enabled",
    key: "dlbEnabled",
    render: value => (value ? "Yes" : "No"),
  },
  { label: "DLB Source", key: "dlbSource" },
  { label: "Phase Count", key: "phaseCount" },
  { label: "Max Current (A)", key: "maxCurrent" },
  {
    label: "Off-Peak Eligible",
    key: "isOffPeakEligible",
    render: value => (value ? "Yes" : "No"),
  },
  {
    label: "Default Off-Peak Eligible",
    key: "isDefaultOffPeakEligible",
    render: value => (value ? "Yes" : "No"),
  },
  {
    label: "Device Ready",
    key: "isDeviceReady",
    render: value => (value ? "Yes" : "No"),
  },
  {
    label: "Off Grid",
    key: "isOffGrid",
    render: value => (value ? "Yes" : "No"),
  },
];
